import Avatar from "components/BaseWidgets/Avatar";
import "./style.scss";
import profilePic from "assets/images/png/dummy_avatar.png";
import { FavouriteFill } from "assets/icons";
import { useNavigate } from "react-router-dom";

function ChatCard({ data, isActive, currentUserId }) {
  // console.log(data, "data");

  const recipientId = data.aec_id;

  // console.log(recipientId, "recipientId");

  const recipient = data;

  const unreadCount = data?.unread_count;

  const navigate = useNavigate();
  return (
    <div
      onClick={() =>
        navigate("/connect/chats", { state: { chatId: data?.chatId } })
      }
      className={`chat-card ${isActive ? "active" : ""}`}
    >
      <div className="flex items-center gap-3 avatar">
        <Avatar
          url={
            recipient?.profile_image &&
            typeof recipient.profile_image === "string"
              ? recipient.profile_image
              : profilePic
          }
          size={48}
        />
        <div className="flex flex-col gap-1">
          <span className="font-body-md leading-3">{recipient?.username}</span>
          <p className={`description font-body-normal `}>
            {data?.last_message}{" "}
          </p>
        </div>
      </div>
      <div className="flex flex-col items-end gap-2 justify-between">
        <span className="font-body-normal leading-1">
          {data.last_message_time_converted}
        </span>
        <div className="flex items-center gap-2">
          {/* TODO: Need implement favorite */}
          {/* {isFav && <FavouriteFill />} */}
          {unreadCount > 0 && <div className="unread-count">{unreadCount}</div>}
        </div>
      </div>
    </div>
  );
}

export default ChatCard;
